<template>
  <div class="board__wrapper">
    <div class="board__list-wrapper">
      <div v-for="status in statusList" :key="status">
        <BoardListTitle
          class="board__list-title"
          :title="status"
          :total="board[status].length"
          :information="$t(`board.columnInfo.${status}`)"
        />
        <div
          class="board__list-group"
          :class="{ open: boardActiveLine === status }"
        >
          <BoardLine
            v-for="item in board[status]"
            :key="item.id"
            :item="item"
            column="OPEN"
          />

          <BoardLineEmpty v-if="!board[status].length" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BoardPendingActions from './BoardPendingActions'
import BoardListTitle from './list/BoardListTitle'
import BoardLine from './list/line/BoardLine'
import BoardLineEmpty from './list/line/BoardLineEmpty'

import { mapGetters } from 'vuex'

export default {
  name: 'BoardListView',

  components: {
    BoardPendingActions,
    BoardListTitle,
    BoardLine,
    BoardLineEmpty,
  },

  props: {
    board: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      statusList: ['OPEN', 'SCHEDULED', 'CANCELED', 'DONE'],
    }
  },

  computed: {
    ...mapGetters(['boardPendingActions', 'boardActiveLine']),
  },
}
</script>
